import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [
      BrowserAnimationsModule
    ],
  })
  export class CoreModule { }
